class SimpleNotebookProviderInfo {
    constructor(viewType, serializer, extensionData) {
        this.viewType = viewType;
        this.serializer = serializer;
        this.extensionData = extensionData;
    }
}
export { SimpleNotebookProviderInfo };
